import { render, staticRenderFns } from "./form-user.vue?vue&type=template&id=67e28a0c&"
import script from "./form-user.vue?vue&type=script&lang=js&"
export * from "./form-user.vue?vue&type=script&lang=js&"
import style0 from "./form-user.vue?vue&type=style&index=0&id=67e28a0c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports